
import { IExternalReference } from "@directives/_veri/externalReference/externalReferences.interfaces";
import { IDriverTachoHours } from "@services/tacho.service";
import { IResourceWithVideoEvents } from "./IResourceWithVideoEvents";
import { IVehicle } from "./IVehicle";
import { IVehicleDriverMapping } from "./IVehicleDriverMapping";

export interface IDriver extends IResourceWithVideoEvents{

    Id?: number;
    //ID?: number;
    Username?: string;
    Name?: string;
    FirstName?: string;
    LastName?: string;
    DisplayName?: string;
    Mobile?: string;
    Email?: string;
    Status?: DriverStatus;
    ButtonId?: string;
    Password?: string;
    Nfc?: string;
    HasImage?: boolean;
    GroupIds?: number[];
    TagIds?: number[];
    Updated?: string;

    // ---

    VehicleDriverMapping?: IVehicleDriverMapping[];
    currentAssignment?: IVehicleDriverMapping;

    vehicle?: IVehicle;
    tacho?: IDriverTachoHours;
    //assignmentEndUtc?: string;
    //assignedVehicleReg?: string;
    externalReferences?: IExternalReference[];
}

export enum DriverStatus {
    Inactive = 0,
    Active = 1,
}
